'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _nukaCarousel = require('nuka-carousel');

var _nukaCarousel2 = _interopRequireDefault(_nukaCarousel);

var _components = require('components');

var _reactMediumImageZoom = require('react-medium-image-zoom');

var _reactMediumImageZoom2 = _interopRequireDefault(_reactMediumImageZoom);

var _config = require('../../config');

var _config2 = _interopRequireDefault(_config);

var _CarouselDecorator = require('./CarouselDecorator/CarouselDecorator.js');

var _CarouselDecorator2 = _interopRequireDefault(_CarouselDecorator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageSlider = function (_Component) {
  (0, _inherits3.default)(ImageSlider, _Component);

  function ImageSlider(props) {
    (0, _classCallCheck3.default)(this, ImageSlider);
    return (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(ImageSlider).call(this, props));
  }

  (0, _createClass3.default)(ImageSlider, [{
    key: 'render',
    value: function render() {
      var styles = require('./ImageSlider.scss');
      var _props = this.props;
      var progress = _props.progress;
      var pics = _props.pics;
      var error = _props.error;

      var baseUrl = _config2.default.assetsUrl; //'https://s3.amazonaws.com/outfeats/';
      var thumbUrl = _config2.default.thumbnailAssetsUrl; //'https://s3.amazonaws.com/outfeats-thumbnails/';
      return _react2.default.createElement(
        'div',
        { className: styles.container },
        _react2.default.createElement(
          'div',
          { className: styles.content },
          pics.length > 0 && _react2.default.createElement(
            'div',
            { className: styles.slider },
            _react2.default.createElement(
              _nukaCarousel2.default,
              { decorators: _CarouselDecorator2.default },
              pics.map(function (pic, i) {
                return _react2.default.createElement(
                  'div',
                  { key: pic, className: styles.pic },
                  _react2.default.createElement(
                    'div',
                    { className: styles.imageContainer },
                    _react2.default.createElement(_reactMediumImageZoom2.default, {
                      zoomMargin: 15,
                      image: {
                        src: thumbUrl + pic
                      },
                      zoomImage: {
                        src: 'https://s3.amazonaws.com/outfeats/' + pic
                      }
                    })
                  )
                );
              })
            )
          )
        )
      );
    }
  }]);
  return ImageSlider;
}(_react.Component);

exports.default = ImageSlider;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/ImageSlider/ImageSlider.js
 ** module id = 1092
 ** module chunks = 0
 **/